import { ChevronsRight } from 'react-feather';
// @ts-ignore
import { animated } from 'react-spring';
import styled, { css } from 'styled-components';
import { color, space, width } from 'styled-system';
import { SCREEN } from '../../../theme/breakpoints';

const isWeb = SCREEN.isWeb;

// top: 0;
// left: 0;
// bottom: 0;
// right: 0;
// padding: ${isWeb ? '10px' : '2px'};
export const SideModalWrap = styled(animated.div)`
  width: calc(71vw / var(--ib-ui-scale, 1));
  z-index: 1000;
  height: calc(100vh / var(--ib-ui-scale, 1));
  overflow: auto;
  display: flex;
  padding: 0px 0px 0px 0px;
  position: fixed;
  right: 0px;
  top: 70px;
  align-items: flex-start;
  box-sizing: border-box;
  justify-content: right;
  background-color: rgba(0, 0, 0, 0);
  font: 'Roboto Condensed', sans-serif;
  font-size: '2';
`;

type SideModalBodyContProps = {
  hasAction?: boolean;
  busy?: boolean;
};

type SideModalHeaderContProps = {
  hasBody?: boolean;
};

export const SideModalInner = styled(animated.div)<any>`
  display: flex;
  max-height: 100%;
  max-width: 100%;
  border-radius: 5px 0px 0px 5px;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  background-color: rgb(230, 230, 230);
  justify-content: center;
  overflow: auto;
  width: ${props =>
    props.hasChildren ? 'auto' : isWeb ? 'calc(46vw / var(--ib-ui-scale, 1))' : 'calc(100vw / var(--ib-ui-scale, 1))'};
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  padding: 15px 10px 10px 10px;
  ${space};
  ${color};
  ${width};
`;

export const SideModalHeaderCont = styled.div<SideModalHeaderContProps>`
  width: 100%;
  display: flex;
  flex: none;
  padding-bottom: 10px;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-start;
  font-weight: 600;

  ${({ hasBody }) =>
    hasBody &&
    css`
      margin-bottom: 0;
    `}
`;

export const SideModalBodyCont = styled.div<SideModalBodyContProps>`
  width: 100%;
  display: flex;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-start;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0px;
  padding-bottom: 40px;
  ${props => {
    if (props.busy) {
      return `
        opacity: 0.4;
        pointer-events: none;
      `;
    }
    return '';
  }}
`;

export const SideModalFooterCont = styled.div`
  width: 100%;
  display: flex;
  padding-top: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const SideModalCloseButton = styled(ChevronsRight)<any>`
  right: 10px;
  width: 30px;
  height: 30px;
  z-index: 1001;
  font-size: 40px;
  font-weight: 600;
  position: absolute;
  color: rgba(0, 0, 0, 0.6);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.9);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;
